import { Button, Dropdown, Input, InputRef, message, Popover, Segmented, Select, Space, Table, TablePaginationConfig, TableProps, Tag, Upload } from "antd"
import AddEditAdvisoryReportModal from "./AddEditAdvisoryReportModal"
import ReportInfoModal from "./ReportInfoModal"
import DeleteModalSimple from "../../Organization/components/DeleteModalSimple"
import { useEffect, useMemo, useRef, useState } from "react"
import { BRANDS, PARTNERS, STATUS_CANCELLED, STATUS_COMPLETED, STATUS_PENDING, USER_TYPE_ADMIN, USER_TYPE_PARTNER } from "../../../constants/constants"
import { deleteBrandAdvisory, deletePartnerAdvisory, getBrandAdvisoryReports, getPartnerAdvisoryReports, getPartnerAdvisoryReportsByPartner, updateBrandAdvisory, updatePartnerAdvisory, uploadBrandAdvisoryReport, uploadPartnerAdvisoryReport } from "../../../API/endpoints/Advisory"
import { getAllOrgs } from "../../../API/endpoints/Organization"
import { FilterDropdownProps } from "antd/es/table/interface"
import SearchIconSmall from "../../../components/icons/SearchIconSmall"
import SortIcon from "../../../components/icons/SortIcon"
import { adversorySubTypeOptions } from "../../../constants/dataConstants"
import FilterIcon from "../../../components/icons/FilterIcon"
import FileIcon from "../../../components/icons/FileIcon"
import Paragraph from "antd/es/typography/Paragraph"
import ThreeDotsIcon from "../../../components/icons/ThreeDotsIcon"
import InfoIcon from "../../../components/icons/InfoIcon"

interface Props {
    userType: string | undefined;
    orgId?: string;
    isPartner?: boolean;
    partnerID?: string;
}
const AdvisoryList = (props: Props) => {
    const { userType, orgId, isPartner, partnerID } = props;
    const searchInput = useRef<InputRef>(null);
    const [activeType, setActiveType] = useState(BRANDS);
    const [selectedOrg, setSelectedOrg] = useState("");

    const [isDeleteItem, setIsDeleteItem] = useState<any>({});
    const [isAdd, setIsAdd] = useState(false);
    const [isEdit, setIsEdit] = useState<any>({});
    const [infoData, setInfoData] = useState<any>({})

    const [searchKey, setSearchKey] = useState("");
    const [orgs, setOrgs] = useState<any[]>([]);

    const [list, setList] = useState<any[]>([])
    const [pageNumber, setPageNumber] = useState(1);
    const [filterStatus, setFilterStatus] = useState("");
    const [filterSubType, setFilterSubType] = useState("");
    const [sortOrderFileName, setSortOrderFileName] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [reload, setReload] = useState(false);

    const [messageApi, contextHolder] = message.useMessage();



    useEffect(() => {
        setLoading(true);
        let where: any = {}
        let sort: any = {}
        if (filterStatus?.length > 0) {
            where = {
                ...where,
                status: filterStatus
            }
        }
        if (filterSubType?.length > 0) {
            where = {
                ...where,
                report_sub_type: filterSubType
            }
        }
        if (sortOrderFileName) {
            sort = {
                file_name: sortOrderFileName
            }
        }

        if (sortOrder) {
            sort = {
                ...sort,
                [activeType === BRANDS || orgId ? "brand_name" : "partner_name"]: sortOrder
            }
        }

        if ((activeType === BRANDS || orgId) && userType !== USER_TYPE_PARTNER) {
            if (selectedOrg || orgId) {
                getBrandAdvisoryReports(selectedOrg || orgId, pageNumber, searchKey, where, sort).then((res: any) => {
                    setList(res?.data?.rows || [])
                    setTotalCount(res?.data?.count);
                    setLoading(false);
                }).catch((err) => {
                    console.error('err', err);
                    setList([]);
                    setLoading(false);
                })
            }
        } else {
            if (userType === USER_TYPE_PARTNER) {
                getPartnerAdvisoryReportsByPartner(partnerID, pageNumber, searchKey, where, sort).then((res: any) => {
                    setList(res?.data?.rows || [])
                    setTotalCount(res?.data?.count);
                    setLoading(false);
                }).catch((err) => {
                    console.error('err', err);
                    setList([]);
                    setLoading(false);
                })
            } else {
                getPartnerAdvisoryReports(pageNumber, searchKey, where, sort).then((res: any) => {
                    setList(res?.data?.rows || [])
                    setTotalCount(res?.data?.count);
                    setLoading(false);
                }).catch((err) => {
                    console.error('err', err);
                    setList([]);
                    setLoading(false);
                })
            }

        }

    }, [orgId, partnerID, userType, activeType, selectedOrg, searchKey, pageNumber, filterStatus, filterSubType, sortOrderFileName, sortOrder, reload])

    useEffect(() => {
        if (userType === USER_TYPE_ADMIN) {
            getAllOrgs().then((res: any) => {
                setOrgs(res?.data || []);
                if (res?.data?.length > 0) {
                    setSelectedOrg(res?.data[0]?.id)
                }
            }).catch((err) => {
                console.error('err', err);

            })
        }

    }, [userType]);


    const handleSearch = (selectedKeys: any, confirm: any) => {
        confirm();
        if (selectedKeys[0] != undefined) {
            setSearchKey(selectedKeys[0]?.trim());
        }
    };

    const onFilterOrSort = (currentPage: any, filters: any, sorter: any) => {
        setFilterStatus(filters?.status || [])
        setFilterSubType(filters?.report_sub_type || [])
        if (sorter?.field === "file_name") {
            setSortOrderFileName(sorter?.order === "ascend" ? "ASC" : sorter?.order === "descend" ? "DESC" : "")
        } else {
            setSortOrderFileName("")
        }

        if (["Partner", "Brand"].includes(sorter?.field)) {
            setSortOrder(sorter?.order === "ascend" ? "ASC" : sorter?.order === "descend" ? "DESC" : "")
        } else {
            setSortOrder("")
        }

        if (currentPage !== pageNumber) {
            setPageNumber(currentPage)
        } else {
            setPageNumber(1)
        }
    }


    const onSuccessDelete = () => {
        messageApi.success("Intelligence deleted successfully");
        const newList = list.filter((item: any) => item?.id !== isDeleteItem?.id)
        setList([...newList])
        setIsDeleteItem({});
    }

    const handleReset = (clearFilters: any) => {
        clearFilters();
        setSearchKey("");
    };

    const onSuccessAdd = (data: any) => {
        setReload(!reload)
        messageApi.success(userType === "admin" ? isEdit?.id ? "Report updated successfully" : "Report added successfully" : isEdit?.id ? "Request updated successfully" : "Request added successfully");
        setIsEdit({});
        setIsAdd(false);
    }

    const onCancelAdd = () => {
        setIsEdit({});
        setIsAdd(false);
    }

    const onRequestCancellation = () => {
        const req = new FormData();
        req.append("status", STATUS_CANCELLED);

        if (activeType === PARTNERS || isPartner || userType === USER_TYPE_PARTNER) {

            updatePartnerAdvisory(isDeleteItem?.id, req).then((res: any) => {
                setReload(!reload)
                messageApi.success("Request cancelled successfully");
                setIsDeleteItem({})
            }).catch((err) => {
                console.log('err', err);

            });
        } else {
            updateBrandAdvisory(isDeleteItem?.id, req).then((res: any) => {
                setReload(!reload);
                messageApi.success("Request cancelled successfully");
                setIsDeleteItem({})
            }).catch((err) => {
                console.log('err', err);

            });
        }

    }

    const handleUploadFile = (file: any, id: string, isBrand: boolean) => {
        if (file) {
            const req = new FormData();
            req.append("file", file)
            if (isBrand) {
                uploadBrandAdvisoryReport(id, req).then((res: any) => {
                    setReload(!reload);
                    messageApi.success("Report uploaded successfully");
                }).catch((err) => {
                    console.log('err', err);

                });
            } else {
                uploadPartnerAdvisoryReport(id, req).then((res: any) => {
                    setReload(!reload);
                    messageApi.success("Report uploaded successfully");
                }).catch((err) => {
                    console.log('err', err);

                });
            }
        }
    };


    const types = [
        {
            label: "Brands",
            value: BRANDS
        },
        {
            label: "Partners",
            value: PARTNERS
        }
    ]

    const statusFilters = [
        {
            text: 'Pending',
            value: STATUS_PENDING,
        },
        {
            text: 'Completed',
            value: STATUS_COMPLETED,
        },
        {
            text: 'Cancelled',
            value: STATUS_CANCELLED,
        },
    ];

    const actionOptions = (record: any) => {
        let items: any = [];

        if (record?.status !== STATUS_CANCELLED) {
            items.push(
                {
                    key: '1',
                    label: "Edit",
                    onClick: () => {
                        setIsEdit(record)
                        setIsAdd(true)
                    }
                }
            )
        }


        items.push({
            key: '2',
            danger: true,
            label: userType === USER_TYPE_ADMIN ? "Delete" : "Cancel Request",
            onClick: () => setIsDeleteItem(record)
        })

        return items;
    }

    const getColumnSearchProps = (dataIndex: any) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }: FilterDropdownProps) => (
            <div style={{ padding: 8 }}>
                <Input
                    classNames={{
                        input: "text-[12px]"
                    }}
                    ref={searchInput}
                    placeholder={`Search`}
                    value={selectedKeys[0]}
                    prefix={<SearchIconSmall />}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm)}
                    className="mb-[8px]"
                />
                <div className="flex gap-2 justify-end">
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        className="text-[12px]"
                    >Reset</Button>
                    <Button
                        type="primary"
                        title="Search"
                        size="small"
                        className="text-[12px]"
                        onClick={() => handleSearch(selectedKeys as string[], confirm)}
                    >Search</Button>
                </div>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchIconSmall color={filtered ? "#0152FB" : "#667085"} />
        ),
    });


    const tableColumns: TableProps['columns'] = useMemo(() => [
        {
            title: activeType === PARTNERS ? "Partner" : "Brand",
            dataIndex: activeType === PARTNERS ? "Partner" : 'Brand',
            key: activeType === PARTNERS ? "Partner" : 'Brand',
            sorter: true,
            sortIcon: ({ sortOrder }) => <SortIcon order={sortOrder} />,
            render: (value: any) => value?.brand_name || value?.name,
            hidden: userType === USER_TYPE_PARTNER

        },
        {
            title: 'Report Sub Type',
            dataIndex: 'report_sub_type',
            key: 'report_sub_type',
            filters: adversorySubTypeOptions,
            filterIcon: (filtered: boolean) => (
                <FilterIcon filtered={filtered} />
            ),
        },
        {
            title: "Document / File Name",
            dataIndex: 'file_name',
            key: 'file_name',
            width: "25%",
            sorter: true,
            sortIcon: ({ sortOrder }) => <SortIcon order={sortOrder} />,
            render: (text, record: any) => (
                text ? (
                    <div className="flex gap-x-[10px] items-center">
                        <FileIcon variant={record?.isPublic ? "success" : ""} />
                        <p className="m-0 text-[12px] font-[500]">{text}</p>
                    </div>
                ) : (
                    <></>
                )


            ),
            ...getColumnSearchProps("file_name")
        },

        {
            title: 'Markets',
            dataIndex: 'markets',
            key: 'markets',
            width: "25%",
            render: (value: string[]) => (
                value?.length > 3 ? (
                    <span>
                        {value?.slice(0, 3)?.join(", ")}
                        <Popover
                            trigger="hover"
                            placement="bottom"
                            content={(
                                <Paragraph className='!mb-0'>
                                    <ul className="!mb-0">
                                        {value?.map((item: any, index: number) => (
                                            <li className="text-[12px]" key={index}>
                                                {item}
                                            </li>
                                        ))
                                        }
                                    </ul>
                                </Paragraph>
                            )}  >
                            <Button type="link" className="!px-0">+{value?.length - 3} more</Button>
                        </Popover>
                    </span>

                ) : (
                    value?.join(", ")
                )
            )
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            filters: statusFilters,
            filterIcon: (filtered: boolean) => (
                <FilterIcon filtered={filtered} />
            ),
            render: (text, record: any) => (
                <Tag
                    bordered={false}
                    color={text === STATUS_COMPLETED ? "success" : text === STATUS_CANCELLED ? "error" : "warning"}
                    className="rounded-[16px] capitalize"
                >
                    {text?.toLowerCase()}
                </Tag>
            ),
        },

        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            align: "end",
            render: (_, record: any) => (
                <Space>
                    {record?.status === STATUS_PENDING && userType === "admin" ? (
                        <Upload
                            className="w-full upload-form-item"
                            onChange={(e: any) => handleUploadFile(e?.file, record?.id, Boolean(record?.brand_id))}
                            beforeUpload={(file) => {
                                return false
                            }}
                            showUploadList={false}
                        >
                            <Button type="primary" size="small" className="text-[12px] leading-[12px]" onClick={(e) => e.preventDefault()}>Upload</Button>
                        </Upload>

                    ) : (
                        <></>
                    )}

                    {record?.status === STATUS_PENDING || userType === "admin" ? (
                        <>
                            <Dropdown menu={{ items: actionOptions(record) }}>
                                <Button icon={<ThreeDotsIcon />} type="text" className="leading-[12px]" onClick={(e) => e.preventDefault()} />
                            </Dropdown>
                        </>
                    ) : (
                        <></>
                    )}


                    <Button icon={<InfoIcon />} type="text" className="leading-[12px]" onClick={(e) => setInfoData(record)} />
                </Space>

            )
        },
    ], [activeType, userType])


    return (
        <div className="h-full bg-[#F2F4F7] p-[16px]">
            {contextHolder}
            <div className="bg-white p-[16px] rounded-[8px] h-full">
                <div className={`flex ${userType == USER_TYPE_ADMIN ? 'justify-between' : 'justify-end'} mb-[16px] stick`}>
                    {userType == USER_TYPE_ADMIN ? (
                        <Segmented
                            options={types}
                            onChange={(value) => {
                                setList([])
                                setPageNumber(1)
                                setActiveType(value)
                                setSortOrder("")
                                setSortOrderFileName("")
                                setSearchKey("")
                            }}
                        />
                    ) : (
                        <></>
                    )}

                    <Space>
                        {activeType === BRANDS && userType == USER_TYPE_ADMIN ? (
                            <Select
                                className="w-[190px]"
                                options={orgs}
                                fieldNames={{ label: "company_name", value: "id" }}
                                rootClassName="rounded-input"
                                onChange={(value: string) => setSelectedOrg(value)}
                                value={selectedOrg}
                            />
                        ) : (
                            <></>
                        )}


                        <Button type="primary" onClick={(e) => setIsAdd(true)} iconPosition="end">{userType === USER_TYPE_ADMIN ? "Add Report" : "Request Report"}</Button>
                    </Space>

                </div>
                <Table
                    size="small"
                    rowKey={"id"}
                    columns={tableColumns}
                    dataSource={list}
                    loading={loading}
                    pagination={{
                        pageSize: 20,
                        current: pageNumber,
                        total: totalCount,
                        showTotal: (total: number, range: [number, number]) => `Showing ${range[0]}–${range[1]} of ${total} items`
                    }}
                    onChange={(pagination: TablePaginationConfig, filters: any, sorter: any) => onFilterOrSort(pagination?.current, filters, sorter)}

                />
            </div>
            <AddEditAdvisoryReportModal
                isPartner={activeType === PARTNERS || Boolean(isPartner) || userType === USER_TYPE_PARTNER}
                isRequest={userType !== USER_TYPE_ADMIN}
                open={isAdd}
                editData={isEdit}
                onCancel={() => onCancelAdd()}
                onSuccess={(data: any) => onSuccessAdd(data)}
                orgID={selectedOrg || orgId}
                partnerID={partnerID}
            />
            <ReportInfoModal
                data={infoData}
                isPartner={activeType === PARTNERS || Boolean(isPartner) || userType === USER_TYPE_PARTNER}
                onClose={() => setInfoData({})}
            />
            <DeleteModalSimple
                title={"Alert"}
                content={
                    userType === USER_TYPE_ADMIN ? (
                        `Are you sure you want to delete this ${userType === USER_TYPE_ADMIN ? 'intelligence report' : 'request'}?`
                    ) : (
                        "Are you sure you want to cancel this request?"
                    )
                }
                okText={userType === USER_TYPE_ADMIN ? "Yes, Delete" : "Yes, Cancel"}
                item={isDeleteItem}
                onCancel={() => setIsDeleteItem({})}
                onSuccess={() => onSuccessDelete()}
                onOk={() => userType !== USER_TYPE_ADMIN ? onRequestCancellation() : null}
                api={activeType == PARTNERS ? deletePartnerAdvisory : deleteBrandAdvisory}
            />
        </div>
    )
}

export default AdvisoryList